// Main-page behavior capture. Shopify checkout/customer-event pixels remain separate.
(() => {
  if (window.femureBehaviorTracking) return;
  const script = document.currentScript;
  const token = script?.dataset.posthogProject;
  if (!token) return;
  window.femureBehaviorTracking = true;
  const market = script.dataset.posthogMarket;
  let loading = false;
  let ready = false;
  let client;
  let pageviewSent = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const internal = new URLSearchParams(window.location.search).get('fv_internal') === '1';

  function synchronize() {
    if (!allowed()) {
      if (ready) {
        client.stopSessionRecording();
        client.opt_out_capturing();
      }
      return;
    }
    if (ready) {
      if (client.has_opted_out_capturing()) {
        client.opt_in_capturing({ capture_event_name: null });
        client.startSessionRecording();
      }
      if (!pageviewSent) {
        pageviewSent = true;
        client.capture('$pageview');
      }
      return;
    }
    if (loading) return;
    loading = true;
    !(function (t, e) {
      var o, n, p, r;
      e.__SV ||
        ((window.posthog = e),
        (e._i = []),
        (e.init = function (i, s, a) {
          function g(t, e) {
            var o = e.split('.');
            2 == o.length && ((t = t[o[0]]), (e = o[1])),
              (t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); });
          }
          (p = t.createElement('script')).type = 'text/javascript';
          p.crossOrigin = 'anonymous';
          p.async = !0;
          p.src = 'https://eu-assets.i.posthog.com' + '/static/array.js';
          (r = t.getElementsByTagName('script')[0]).parentNode.insertBefore(p, r);
          var u = e;
          for (void 0 !== a ? (u = e[a] = []) : (a = 'posthog'),
            u.people = u.people || [],
            u.toString = function (t) { var e = 'posthog'; return 'posthog' !== a && (e += '.' + a), t || (e += ' (stub)'), e; },
            u.people.toString = function () { return u.toString(1) + '.people (stub)'; },
            o = 'init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug getPageViewId'.split(' '),
            n = 0; n < o.length; n++) g(u, o[n]);
          e._i.push([i, s, a]);
        }),
        (e.__SV = 1));
    })(document, window.posthog || []);


    window.posthog.init(token, {
      api_host: 'https://eu.i.posthog.com',
      ui_host: 'https://eu.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: true,
      enable_recording_console_log: false,
      session_recording: { maskAllInputs: true },
      before_send: event => allowed() ? event : null,
      loaded: instance => {
        client = instance;
        instance.register({
          site_domain: window.location.hostname,
          site_type: 'store',
          market,
          tracking_source: 'storefront',
          ...(internal ? { is_employee: true } : {}),
        });
        ready = true;
        synchronize();
      },
    });
  }

  document.addEventListener('visitorConsentCollected', synchronize);
  if (window.Shopify?.customerPrivacy) synchronize();
  else window.Shopify?.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (!error) synchronize();
  });
})();
